import { useEffect, useState, useRef } from "react";
import { ReactTable } from "../common";
import { Message, Icon } from "semantic-ui-react";
import { canEditAll, getCSRFToken, fetchWithAuth } from "../auth";
import { LoadingWrapper } from "../common";
import "../../css/members.css"
import { Link } from "react-router-dom";
import { statusMap } from "../common/helpers";


export const Events = (props) => {
    const [events, setEvents] = useState({})
    const [columnInfo, setColumnInfo] = useState([])
    const [loaded, setLoaded] = useState(false)
    const [teams, setTeams] = useState({})
    const selectedRef = useRef({})
    const [error, setError] = useState('')

    function updateConflicts(allEvents) {
        for (const teamName of Object.keys(allEvents)) {
            const teamEvents = allEvents[teamName]
            const starts = teamEvents.filter((event) => event.approvalStatus !== 'denied').map((event) => {
                return {
                    time: event.start,
                    type: 'start',
                    event: event,
                    conflictId: null
                }
            })
            const ends = teamEvents.map((event) => {
                return {
                    time: event.end,
                    type: 'end',
                    event: event,
                    conflictId: null
                }
            })
            const allTimes = [...starts, ...ends]
            const sortedTimes = allTimes.sort((a, b) => {
                if (a.time < b.time) {
                    return -1
                } else if (a.time > b.time) {
                    return 1
                } else if (b.type === 'start' && a.type === 'end') {
                    // need to do ends first otherwise we still have an
                    // event open
                    return -1
                } else {
                    return 0
                }
            })
            const openTimes = []
            let numOpen = 0
            let currentConflictId = 0
            let hadConflict = false
            for (const time of sortedTimes) {
                if (time.type === 'start') {
                    if (numOpen > 0) {
                        hadConflict = true
                        openTimes[openTimes.length - 1].event.conflictId = currentConflictId
                    }
                    openTimes.push(time)
                    if (numOpen > 0) {
                        openTimes[openTimes.length - 1].event.conflictId = currentConflictId
                    }
                    numOpen++
                } else {
                    if (numOpen === 1 && hadConflict) {
                        currentConflictId++
                        hadConflict = false
                    }
                    numOpen = numOpen > 0 ? numOpen - 1 : 0
                }
            }
        }
    }

    async function getEvents() {
        setLoaded(false)
        setError('')
        const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'events/?only_my_approvals=true', {
            headers: { 'X-CSRFToken': getCSRFToken() },
            credentials: 'include'
        })
        if(!resp.ok) {
            setError("Something went wrong.")
            setLoaded(true)
            return
        }
        const respJson = await resp.json()
        const sortedEvents = respJson.sort((eventA, eventB) => {
            if (eventA.approvalStatus === eventB.approvalStatus) {
                return eventB.start.localeCompare(eventA.start)
            }
            return eventA.approvalStatus === 'pending' ? -1 : 1
        })
        const newTeams = {}
        const newEvents = {}
        for (const event of sortedEvents) {
            if (event.teams.length === 0) {
                if (newEvents['noTeam']){
                    newEvents['noTeam'].push(event)
                    newTeams['noTeam'] = 'No team'
                }else{
                    newEvents['noTeam'] = [event]
                }
            }
            for (const team of event.teams) {
                if (!newEvents.hasOwnProperty(team.id)) {
                    newEvents[team.id] = []
                    newTeams[team.id] = team.name
                }
                newEvents[team.id].push(event)
            }
        }

        setTeams(newTeams)

        updateConflicts(newEvents)

        setEvents(newEvents)
        setLoaded(true)
    }

    function updateSelected(ev) {
        selectedRef.current = { ...selectedRef.current, ...ev }
    }

    useEffect(() => {
        getEvents()
    }, [])


    useEffect((isEdit) => {
        setColumnInfo([
            {
                Header: "Title",
                accessor: "title",
                Cell: (row) => {
                    const eventId = row.row.original.id
                    return <Link to={'/events/' + eventId + '/'}>{row.row.original.title}</Link>
                }
            },
            {
                Header: "Member",
                accessor: "member.name",
                Cell: (row) => {
                    return <Link to={'/members/' + row.row.original.member.userId + '/view'}>{row.row.original.member.name}</Link>
                }
            },
            {
                Header: "Approval Status",
                accessor: "approvalStatus",
                Cell: (row) => {
                    return <div>{statusMap[row.row.original.approvalStatus]} {row.row.original.approvalStatus === 'pending' ? <Icon className="exclamation circle" color="red" /> : <></>}</div>
                }
            }
        ])
    }, [])

    function countPending(acc, currEvent) {
        if (currEvent.approvalStatus === 'pending') {
            return acc + 1
        }
        return acc
    }

    if(Object.keys(events).length === 0) {
        return <div style={{ fontWeight: 'bold' }}>There are no absences to approve or deny.</div>
    }

    return (
        <div>
            {error !== '' &&
                <Message style={{ width: "fit-content" }} compact negative>{error}</Message>
            }
            <LoadingWrapper loading={!loaded} text="Loading events">
                <div>
                    <Icon className="exclamation circle" /> Conflicting rows are highlighted in the same shade. Teams are sorted by the number of pending absences.
                </div>
                <div style={{ display: 'flex', justifyContent: "center", width: '100%', flexWrap: "wrap", flexDirection: "column", paddingBottom: "2rem" }}>
                    {Object.keys(events).sort((eventTeamA, eventTeamB) => {
                        return events[eventTeamB].reduce(countPending, 0) - events[eventTeamA].reduce(countPending, 0)
                    }).map((eventTeam, index) => {
                        return <div key={index}>
                            <div style={{ fontWeight: "bold", margin: "1rem" }}>
                                <Link to={'/teams/' + eventTeam + '/calendar'}>{teams[eventTeam]}</Link>
                            </div>
                            <div>
                                <ReactTable
                                    hideGlobalFilter
                                    className="channel-table"
                                    data={events[eventTeam].map((event) => {
                                        return {
                                            teamName: eventTeam,
                                            ...event
                                        }
                                    })}
                                    columns={columnInfo}
                                    hiddenColumns={['id']}
                                    editable={canEditAll()}
                                    setEdit={updateSelected}
                                    getRowProps={(row) => {
                                        if (row.original.conflictId != null) {
                                            return {
                                                'style': { backgroundColor: row.original.conflictId % 2 ? '#FFBFBF' : '#FFDDDD' }
                                            }
                                        } else {
                                            return {
                                                'style': { backgroundColor: 'white' }
                                            }
                                        }
                                    }}

                                />
                            </div>
                            {index !== Object.keys(events).length - 1 && <div className="divider-bottom" />}
                        </div>
                    })}
                </div>
            </LoadingWrapper>
        </div>
    );
}